// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"176":"styles","348":"component---src-pages-index-tsx","968":"8a128373"}[chunkId] || chunkId) + "-" + {"8":"654e8163ad0521c47f79","176":"f0f8ddefe7494df5a53d","315":"3efb9fc3edffb5a4df3a","348":"4befde5d665d98e08cb8","968":"d2e4cde5bc87950f335f"}[chunkId] + ".js";
};